const NO_ANOMALY_CHART_COLOR = "#9095a469";

function buildEmptyAnomalyChart(t) {
  return {
    values: [1],
    labels: [t("No sorting errors detected")],
    colors: [NO_ANOMALY_CHART_COLOR],
    // Placeholder row is not a real material — keep key null so clicks no-op.
    keys: [null],
    chartTotal: 1,
    numberOfAnomaly: 0,
  };
}

export function buildAnomalyChartFromDelivery(
  anomalyDelivery,
  numberOfAnomaly,
  t,
  formattedColorMaterial,
) {
  const count = Number(numberOfAnomaly) || 0;

  if (count === 0) {
    return buildEmptyAnomalyChart(t);
  }

  const keys = Object.keys(anomalyDelivery || {});

  if (keys.length === 0) {
    return buildEmptyAnomalyChart(t);
  }

  return {
    values: keys.map((key) => anomalyDelivery[key]),
    labels: keys.map((key) => t(key)),
    colors: keys.map((key) => formattedColorMaterial(key)),
    keys,
    chartTotal: count,
    numberOfAnomaly: count,
  };
}

export function buildMergedAnomalyChart(
  collections,
  t,
  formattedColorMaterial,
) {
  const merged = {};
  let total = 0;

  for (const collection of collections) {
    if (!collection) continue;

    for (const [key, value] of Object.entries(
      collection.anomalyDelivery || {},
    )) {
      merged[key] = (merged[key] || 0) + value;
      total += value;
    }
  }

  return buildAnomalyChartFromDelivery(
    merged,
    total,
    t,
    formattedColorMaterial,
  );
}
